import React, { useState, createContext, useContext } from 'react';

// Create Alert Context
const AlertContext = createContext();

// Alert Provider Component
export const AlertProvider = ({ children }) => {
    const [alerts, setAlerts] = useState([]);

    const showAlert = (message, type = 'info', duration = 5000) => {
        const id = Date.now();
        const newAlert = { id, message, type };
        setAlerts(prev => [...prev, newAlert]);

        if (duration > 0) {
            setTimeout(() => removeAlert(id), duration);
        }

        return id;
    };

    const removeAlert = (id) => {
        setAlerts(prev => prev.filter(alert => alert.id !== id));
    };

    return (
        <AlertContext.Provider value={{ showAlert, removeAlert }}>
            {children}
            <div className="alert-container">
                {alerts.map(alert => (
                    <AlertBox
                        key={alert.id}
                        message={alert.message}
                        type={alert.type}
                        onClose={() => removeAlert(alert.id)}
                    />
                ))}
            </div>
        </AlertContext.Provider>
    );
};

// Alert Box Component
const AlertBox = ({ message, type = 'info', onClose }) => {
    const getIcon = () => {
        switch(type) {
            case 'success': return '✅';
            case 'error': return '❌';
            case 'warning': return '⚠️';
            default: return 'ℹ️';
        }
    };

    return (
        <div className={`alert alert-${type}`}>
            <div className="alert-content">
                <span className="alert-icon">{getIcon()}</span>
                <span className="alert-message">{message}</span>
            </div>
            <button className="alert-close" onClick={onClose}>×</button>
        </div>
    );
};

// Custom hook to use alerts
export const useAlert = () => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error('useAlert must be used within an AlertProvider');
    }
    return context;
};